/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef
} from 'react';
import Gallery from 'react-grid-gallery';
import { formatMessage } from 'devextreme/localization';
import { confirm } from 'devextreme/ui/dialog';
import {
  ScrollView, Button, FileUploader
} from 'devextreme-react';
import Form, {
  SimpleItem,
  RequiredRule,
  GroupItem,
  ButtonItem
} from 'devextreme-react/form';
import PopupMVP from '../../components/PopupMVP';
import style from './supportform.module.scss';

const email = {
  body: null
};

const SupportForm = ({
  supportReducer: {
    loading,
    success,
    processing,
    visible,
    number,
    data,
    listPhotos,
    okPhoto,
    okSendEmail
  },
  closeSupportWindow,
  getSupportNextNumber,
  delSupportNumber,
  supportGetListPhotos,
  supportAddPhoto,
  supportDelPhoto,
  supportSendEmail
}) => {
  const fileUploader = useRef(null);
  const form = useRef(null);
  const [filePhoto, setFilePhoto] = useState(null);
  const [listPhotosOnComponent, setListPhotosOnComponent] = useState([]);
  const [isVisButDelPhoto, setIsVisButDelPhoto] = useState(false);
  const [supportNumber, setSupportNumber] = useState(null);
  const [height, setHeight] = useState(window.innerHeight < 650 ? window.innerHeight - 20 : 630);

  useEffect(() => {
    if (visible && !supportNumber) {
      getSupportNextNumber();
    }
  }, [
    getSupportNextNumber,
    supportNumber,
    visible
  ]);

  useEffect(() => {
    if (number && visible) {
      setSupportNumber(number);
    }
  }, [number, visible]);

  const urltoFile = (url, filename, mimeType) => {
    // eslint-disable-next-line no-param-reassign
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
    return (fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], filename, { type: mimeType }))
    );
  };

  const fileGetPreview = useCallback((blobFile) => {
    try {
      const reader = new FileReader();

      if (blobFile.type.includes('image')) {
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
          urltoFile(reader.result, blobFile.name)
            .then((file) => {
              supportAddPhoto({
                supportNumber,
                file
              });
            });
        };

        reader.onerror = () => {
          console.log(reader.error);
        };
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }, [supportAddPhoto, supportNumber]);

  const getPhotosListForModal = useCallback(() => {
    if (supportNumber && visible) {
      supportGetListPhotos({ supportNumber });

      if (data.attachments) data.attachments.forEach((el) => fileGetPreview(el));
    }
  }, [data.attachments, fileGetPreview, supportGetListPhotos, supportNumber, visible]);

  /** Получение списка фотографий */
  useEffect(() => {
    getPhotosListForModal();
  }, [supportNumber, supportGetListPhotos, data, supportAddPhoto, visible, getPhotosListForModal]);

  /** Закрытие модального окна */
  const modalOnHiding = useCallback(() => {
    setListPhotosOnComponent([]);
    closeSupportWindow();
    delSupportNumber();
    setSupportNumber(null);
  }, [setListPhotosOnComponent, closeSupportWindow, setSupportNumber, delSupportNumber]);

  /** Если сообщение отправилось, опорожняем форму */
  useEffect(() => {
    if (
      okSendEmail
      && form
      && form.current
      && form.current.instance
    ) {
      form.current.instance.resetValues();
      modalOnHiding();
    }
  }, [okSendEmail, form, modalOnHiding]);

  /** Если фотография загрузилась удачно, опорожняем компонент fileUploader */
  useEffect(() => {
    if (
      okPhoto
      && fileUploader
      && fileUploader.current
      && fileUploader.current.instance
    ) {
      setFilePhoto(null);
      fileUploader.current.instance.reset();
    }
  }, [okPhoto, fileUploader]);

  useEffect(() => {
    if (listPhotos && listPhotos.length) {
      setListPhotosOnComponent(listPhotos.map((item) => (
        {
          src: item.storedFileUrl,
          thumbnail: item.storedFileUrl,
          thumbnailWidth: 200,
          thumbnailHeight: 180,
          storedFileName: item.storedFileName,
          attachmentId: item.attachmentId,
          isSelected: false
        }
      )));
      setIsVisButDelPhoto(false);
    } else if (listPhotos && !listPhotos.length) {
      setListPhotosOnComponent([]);
      setIsVisButDelPhoto(false);
    }
  }, [listPhotos]);

  /** событие при выборе фотографии */
  const onSelectImage = useCallback((index, image) => {
    setListPhotosOnComponent((images) => {
      const updatedImages = images.map((img, i) => {
        if (i === index) {
          return { ...img, isSelected: !img.isSelected };
        }
        return img;
      });

      const hasSelected = updatedImages.some((item) => item.isSelected);
      setIsVisButDelPhoto(hasSelected);

      return updatedImages;
    });
  }, []);

  /** Отображение фотографий */
  const renderPhotosList = useMemo(() => {
    if (listPhotosOnComponent.length) {
      return (
        <div>
          <span>Предпросмотр файлов:</span>
          <div className={style.imagesContainer}>
            <Gallery
              images={listPhotosOnComponent}
              enableImageSelection
              onSelectImage={onSelectImage}
              enableLightbox={false}
            />
          </div>
        </div>
      );
    }
    return (<div className={style.textPhoto}>{formatMessage('support').notData}</div>);
  }, [
    listPhotosOnComponent,
    onSelectImage
  ]);

  /** Сохранение фотографии */
  const onClickSavePhoto = useCallback(() => {
    supportAddPhoto({
      file: filePhoto[0],
      supportNumber
    });
  }, [
    filePhoto,
    supportAddPhoto,
    supportNumber
  ]);

  /** Загрузка фотографии */
  const onFilesUpload = useCallback(({ value, component }) => {
    // eslint-disable-next-line no-underscore-dangle
    const files = component._files;
    if (files[0] && files[0].isValidFileExtension) {
      setFilePhoto(value);
    } else {
      setFilePhoto(null);
    }
  }, []);

  /** И рендер */
  const renderUploadPhoto = useMemo(() => (
    <FileUploader multiple={false}
                  uploadMode="useForm"
                  ref={fileUploader}
                  allowedFileExtensions={['.jpg', '.jpeg', '.png']}
                  onValueChanged={onFilesUpload}
    />
  ), [onFilesUpload]);

  /** Удаление фотографии */
  const onClickDelPhoto = useCallback(() => {
    confirm('<div style="width: 300px"></div>', formatMessage('workingDetailing').deleteSelectPhoto).then((dialogResult) => {
      if (dialogResult) {
        supportDelPhoto({
          listPhotos: listPhotosOnComponent
            .filter((item) => item.isSelected)
            .map((item) => item.attachmentId),
          supportNumber
        });
      }
    });
  }, [
    listPhotosOnComponent,
    supportDelPhoto,
    supportNumber
  ]);
  const RenderDelPhoto = useCallback(() => (
    <Button type="danger"
            stylingMode="contained"
            text={formatMessage('workingDetailing').deleteText}
            onClick={onClickDelPhoto}
            elementAttr={{ style: !isVisButDelPhoto && 'display: none;' }}
    />
  ), [onClickDelPhoto, isVisButDelPhoto]);

  /** Отправка email */
  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    const requestData = {
      ...email,
      supportNumber
    };

    const plantId = localStorage.getItem('plantId');
    if (plantId && plantId !== '-1') {
      requestData.plantId = plantId;
    }

    supportSendEmail(requestData);
  }, [
    supportNumber,
    supportSendEmail
  ]);

  /** Рендер полей обращения и кнопки "отправить" */
  const renderEmail = useMemo(() => (
    <form method="POST"
          onSubmit={formOnSubmit}
    >
      <Form labelLocation="top"
            width="100%"
            readOnly={false}
            showColonAfterLabel
            showValidationSummary={false}
            formData={email}
            ref={form}
      >
        <GroupItem>
          <SimpleItem dataField="body"
                      editorType="dxTextArea"
                      label={{ text: formatMessage('support').message }}
                      editorOptions={{ stylingMode: 'filled' }}
          >
            <RequiredRule message={formatMessage('support').errorMessage} />
          </SimpleItem>
          <ButtonItem horizontalAlignment="right"
                      buttonOptions={{
                        text: formatMessage('support').send,
                        type: 'default',
                        useSubmitBehavior: true
                      }}
          />
        </GroupItem>
      </Form>
    </form>
  ), [formOnSubmit]);

  const updateHeight = () =>
    window.innerHeight < 650
      ? setHeight(window.innerHeight - 20)
      : setHeight(630);

  useEffect(() => {
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <PopupMVP title={`Регистрация инцидента ${supportNumber}`}
              visible={visible}
              width={750}
              height={height}
              onHiding={modalOnHiding}
    >
      <div className={style.container}>
        <ScrollView scrollByContent
                    scrollByThumb
                    height={height - 90}
                    showScrollbar="always"
                    width={700}
        >
          <div className={style.photo}>
            <span>{formatMessage('support').photo}</span>
            { renderUploadPhoto }
            <div className="divRight">
              <Button type="default"
                      stylingMode="contained"
                      onClick={onClickSavePhoto}
                      text={formatMessage('support').add}
                      disabled={!filePhoto}
                />
              <RenderDelPhoto />
            </div>
            <div>
              { renderPhotosList }
            </div>
          </div>
          <div className={style.email}>
            {renderEmail}
          </div>
        </ScrollView>
      </div>
    </PopupMVP>
  );
};

export default SupportForm;
